module.exports = __webpack_public_path__ + "static/media/letsride.c76ba549.jpg";